import { UserRole } from '@hms/shared';

/** Names of the lab routes (CORA-448), shared by the router and the screens that link to them. */
export const LabRoute = {
  Board: 'LabBoard',
  ResultEntry: 'LabResultEntry',
  ReviewQueue: 'LabReviewQueue',
  CriticalResults: 'CriticalResults',
  ExamWorklist: 'ExamWorklist',
} as const;
export type LabRoute = (typeof LabRoute)[keyof typeof LabRoute];

export const LAB_BOARD_PATH = '/lab/board';
export const LAB_REVIEW_QUEUE_PATH = '/lab/review-queue';
/** The exam worklist of lab and imaging (CORA-451); technicians land on it (B44). */
export const EXAM_WORKLIST_PATH = '/exams/worklist';
/** The ordering doctor's critical results (CORA-450, B39). */
export const CRITICAL_RESULTS_PATH = '/critical-results';

/** The entry page of an order's lab result (CORA-449). */
export const labResultEntryPath = (examOrderId: string): string => `/lab/results/${examOrderId}`;

// The roles of GET /lab-samples/board: technicians run the board, the hospital admin oversees it.
export const LAB_BOARD_ROLES: string[] = [UserRole.TECHNICIAN, UserRole.HOSPITAL_ADMIN];

// Technicians enter and validate values (CORA-444).
export const LAB_RESULT_ENTRY_ROLES: string[] = [UserRole.TECHNICIAN];

// The review queue's API serves doctors; the menu shows it to pathologists only (B45).
export const LAB_REVIEW_QUEUE_ROLES: string[] = [UserRole.DOCTOR];

// The alerts go to the ordering doctor (CORA-446).
export const CRITICAL_RESULTS_ROLES: string[] = [UserRole.DOCTOR];

// The roles of GET /exam-orders/worklist (CORA-442).
export const EXAM_WORKLIST_ROLES: string[] = [UserRole.TECHNICIAN, UserRole.DOCTOR, UserRole.NURSE, UserRole.ADMIN, UserRole.HOSPITAL_ADMIN];
